import {FmlxSwitch} from 'fmlx-common-ui';
import PropTypes from 'prop-types';
import './FastSwitch.scss';

const AddedSize = {EXTRA_EXTRA_SMALL: 'xxs', THIN: 'thin'};
const Size = {...FmlxSwitch.Size, ...AddedSize};

/**
 * Switch component, based of FmlxSwitch with smaller size options
 */
function FastSwitch({size, ...props}) {
  return (
    <span className={`fast-switch fast-switch-${size}`}>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <FmlxSwitch {...props} size={size} />
    </span>
  );
}

FastSwitch.propTypes = {
  size: PropTypes.string,
};

FastSwitch.defaultProps = {
  size: FmlxSwitch.Size.EXTRA_SMALL,
};

FastSwitch.Size = Size;

export default FastSwitch;
